import { render, staticRenderFns } from "./TermsAndPolicies.vue?vue&type=template&id=3aca63ee&scoped=true"
import script from "./TermsAndPolicies.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aca63ee",
  null
  
)

export default component.exports